module.exports = __webpack_public_path__ + "static/media/11.a3e9b1f4.JPG";